import script from "./DeviceDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceDetails.vue?vue&type=script&lang=ts&setup=true"

import "./DeviceDetails.vue?vue&type=style&index=0&id=124ee33e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124ee33e"]])

export default __exports__